import { Stack } from '@mui/material';
import React from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { ChartTooltip, colours as constColours } from '../../consts';
import { THEME_MODES } from '../../helpers/constant';
import { useThemeMode } from '../theme';
import { AppChartCirclePattern, AppChartWavePattern } from './chart-pattern';

function AppPieChart({ data }) {
    const { themeMode, colours, FONT } = useThemeMode();

    const barColors = [
        [colours.primary100, colours.primary100],
        [colours.purple100, colours.purple100],
        [colours.dividergray, colours.dividergray],
    ];

    // when no data in response.
    if (!data?.length) {
        return (<Stack fontSize={FONT.SIZE_14} height="100%" alignItems="center" justifyContent="center">
            No Data Available
        </Stack>)
    }

    // calculate total to get %
    const total = data.reduce((sum, item) => sum + item.value, 0);

    return (
        <ResponsiveContainer width="100%" height="100%">
            <PieChart>
                <defs>
                    {barColors.map((color, index) => (
                        <linearGradient
                            key={"linearGradient-" + index}
                            id={`color2Uv${index}`}
                            x1="0"
                            y1="0"
                            x2="100%"
                            y2="100%"
                            spreadMethod="reflect"
                        >
                            <stop offset="0" stopColor={color[0]} />
                            <stop offset="1" stopColor={color[1]} />
                        </linearGradient>
                    ))}
                    
                    {/* Circle pattern for Agent */}
                    {barColors.map((color, index) => (
                        <AppChartCirclePattern
                            patternId="chartCirclePie"
                            color={color[0]}
                            index={index}
                            key={`circle-${index}`}
                        />
                    ))}

                    {/* Wave pattern for Client */}
                    {barColors.map((color, index) => (
                        <AppChartWavePattern
                            patternId="chartWavePie"
                            color={color[0]}
                            index={index}
                            key={`wavePie-${index}`}
                        />
                    ))}
                </defs>

                {/* Outer Pie Border */}
                <Pie
                    cx="50%"
                    cy="50%"
                    outerRadius="91%"
                    innerRadius="90%"
                    fill="none"
                    stroke={(themeMode === THEME_MODES.DARK || themeMode === THEME_MODES.HIGH_CONTRAST) ? constColours.black : colours.white}
                    strokeWidth={1}
                    isAnimationActive={false}
                />

                <Pie
                    dataKey="value"
                    startAngle={360}
                    endAngle={0}
                    data={data}
                    cx="50%"
                    cy="50%"
                    outerRadius="90%"
                    stroke={(themeMode === THEME_MODES.DARK || themeMode === THEME_MODES.HIGH_CONTRAST) ? constColours.black : colours.white}
                    strokeWidth={2}
                >
                    {data.map((entry, index) => {
                        const name = entry.name?.toLowerCase();
                        let fill = `url(#color2Uv${index})`;

                        if (themeMode === THEME_MODES.COLOR_VISION) {
                            if (name === "agent") {
                                fill = `url(#chartCirclePie${index})`;
                            } else if (name === "client") {
                                fill = `url(#chartWavePie${index})`;
                            }
                        }

                        return <Cell key={`cell5-${index}`} fill={fill} aria-label={`${entry.name}: ${(entry.value / total * 100).toFixed(0)}%`} />;
                    })}
                </Pie>
                <Tooltip
                    formatter={(value) => {
                        const percent = ((value / total) * 100).toFixed(0) + "%";
                        return percent;
                    }}
                    contentStyle={ChartTooltip(colours, FONT)}
                    itemStyle={{ color: colours.white }}
                    cursor={false}
                />
                <Legend
                    align="right"
                    layout="vertical"
                    verticalAlign="middle"
                    iconType="circle"
                    iconSize={themeMode === THEME_MODES.COLOR_VISION ? 20 : 8}
                    wrapperStyle={{
                        fontSize: FONT.SIZE_14,
                        fontWeight: 600,
                        lineHeight: 2,
                    }}
                    formatter={(v, e, i) => {
                        return (
                            v + " " + ((e.payload.percent * 100) || 0).toFixed(0) + "%"
                        );
                    }}
                />
            </PieChart>
        </ResponsiveContainer>
    )
}

export default AppPieChart